import { FC, InputHTMLAttributes, PropsWithChildren, ReactNode } from 'react';
import { NavButtons } from './navButtons';
import Skeleton from './presentational/skeleton';
import cx from 'classnames';
import { Stack } from './stack/Stack';

export type PaginationSearchConfig = {
  search: string;
  onSearch: (search: string) => void;
  inputProps?: Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'>;
};

export type PaginationPropsType = {
  navButtonsProps: any;
  searchConfig?: PaginationSearchConfig;
  top?: boolean | ReactNode;
  bottom?: boolean;
  upperChildren?: ReactNode;
  bottomChildren?: ReactNode;
  removeVerticalMargins?: boolean;
};

const Pagination: FC<PropsWithChildren<PaginationPropsType>> = ({
  children,
  navButtonsProps,
  top = true,
  bottom = true,
  searchConfig,
  upperChildren,
  bottomChildren,
  removeVerticalMargins
}) => {
  const skeletonPaginationButtons = (
    <div style={{ display: 'flex', margin: '12px 0' }}>
      <Skeleton width={68} height={27} style={{ marginRight: 16, borderRadius: '0.25rem' }} />
      <Skeleton width={69} height={27} style={{ marginRight: 16, borderRadius: '0.25rem' }} />
      <Skeleton width={71} height={27} style={{ marginRight: 16, borderRadius: '0.25rem' }} />
      <Skeleton width={67} height={27} style={{ marginRight: 16, borderRadius: '0.25rem' }} />
    </div>
  );
  return navButtonsProps ? (
    <>
      {top && (
        <div className="slds-grid slds-wrap slds-grid--align-spread slds-grid--vertical-align-center pagination-row pagination-row-upper">
          <div className="slds-col">
            {top === true ? (
              <NavButtons
                className={cx(
                  'slds-m-bottom--small pagination-nav-buttons',
                  !removeVerticalMargins && 'slds-m-top--medium'
                )}
                {...navButtonsProps}
              />
            ) : (
              top
            )}
          </div>
          {(searchConfig || upperChildren) && (
            <div className="slds-col">
              <Stack>
                {upperChildren}
                {searchConfig && (
                  <input
                    type="search"
                    className="slds-input"
                    placeholder="Search"
                    value={searchConfig.search}
                    onChange={(e) => searchConfig.onSearch(e.target.value)}
                    {...searchConfig.inputProps}
                  />
                )}
              </Stack>
            </div>
          )}
        </div>
      )}

      {children}
      {bottom && (
        <div className="slds-grid slds-wrap slds-grid--align-spread slds-grid--vertical-align-center pagination-row pagination-row-bottom">
          <div className="slds-col">
            <NavButtons
              className={cx(
                'slds-m-top--small pagination-nav-buttons',
                !removeVerticalMargins && 'slds-m-bottom--x-large'
              )}
              {...navButtonsProps}
            />
          </div>
          {bottomChildren && <div className="slds-col">{bottomChildren}</div>}
        </div>
      )}
    </>
  ) : (
    <>
      {top && skeletonPaginationButtons}
      {children}
      {bottom && skeletonPaginationButtons}
    </>
  );
};

export default Pagination;
